import React, { FC } from "react";
import PageLayout from "layouts/PageLayout";
import PageHeader from "containers/PageHeader";
import BucketsPageContent from "containers/BucketsPageContent/BucketsPageContent";

const BucketsPage: FC = () => {

  return (
    <PageLayout>
      <PageHeader title="Storage" />
      <BucketsPageContent />
    </PageLayout>
  );
};

export default BucketsPage;
